<div id="st-no-data-found-block" class="d-flex align-items-center justify-content-center flex-column h-100"
>

<div id="st-no-data-found-nodatafound" class="no_data_found">{{'no_data_found' | translate}} </div>
</div>